import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import {FormsModule} from '@angular/forms';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { CorporateSocailResponsibilityPolicyComponent } from './corporate-socail-responsibility-policy/corporate-socail-responsibility-policy.component';
import { ServicesComponent } from './services/services.component';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { EstimateComponent } from './estimate/estimate.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { LoginComponent } from './login/login.component';


@NgModule({
  declarations: [HomeComponent, DisclaimerComponent, CorporateSocailResponsibilityPolicyComponent, ServicesComponent, PortfolioComponent, EstimateComponent, AboutUsComponent, ContactUsComponent, LoginComponent],
    imports: [
        CommonModule,
        HomeRoutingModule,
        FormsModule
    ]
})
export class HomeModule { }
